export const MODAL_VIEWS = [
  {
    size: "lg",
    views: [
      "PRODUCT_EXPORT_VIEW",
      "PRODUCT_IMPORT_VIEW",
      "ORDER_SELECT_ADDRESS_VIEW",
      "USER_EXPORT_VIEW",
      "SEARCH_TERM_EXPORT_VIEW",
      "USER_IMPORT_VIEW",
    ],
  },
  {
    size: "none",
    views: [
      "DISCOUNT_PRODUCT_VIEW",
      "DISCOUNT_CATEGORY_VIEW",
      "DISCOUNT_USER_VIEW",
      "DISCOUNT_CUSTOMER_GROUP_VIEW",
      "CATEGORY_PRODUCT_VIEW",
      "ORDER_PRODUCT_VIEW",
      "PREVIEW_STATIC_BLOCK",
    ],
  },
];

export const MAX_LG_MODAL_VIEWS = [
  "2FA_AUTHENTICATION_VIEW",
  "PRODUCT_EXPORT_VIEW",
  "PRODUCT_IMPORT_VIEW",
  "ORDER_SELECT_ADDRESS_VIEW",
  "USER_EXPORT_VIEW",
  "SEARCH_TERM_EXPORT_VIEW",
  "USER_IMPORT_VIEW",
  "STORE_IMPORT_FORM",
  "WALLET_RULE_ADD_SKU_VIEW",
];

export const NO_MAX_MODAL_VIEWS = [
  "DISCOUNT_PRODUCT_VIEW",
  "DISCOUNT_CATEGORY_VIEW",
  "DISCOUNT_USER_VIEW",
  "DISCOUNT_CUSTOMER_GROUP_VIEW",
  "CATEGORY_PRODUCT_VIEW",
  "ORDER_PRODUCT_VIEW",
  "PREVIEW_STATIC_BLOCK",
  "NOTIFICATION_TARGET_DUPLICATE_MODAL",
];
